import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { formatPrismicImage } from '~/helpers/image-helper';

var GlobalRichText = function GlobalRichText() {
  return import(
  /* webpackChunkName:"global-editorial" */
  '~/components/atoms/Editorial/Global/GlobalRichText.vue');
};

export default {
  components: {
    GlobalRichText: GlobalRichText
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  computed: {
    currentPayload: function currentPayload() {
      return {
        image: "".concat(formatPrismicImage(this.payload.primary.img.url, [['ar_16:9', 'c_fill', 'g_auto'], 'w_375']), " 375w, ").concat(formatPrismicImage(this.payload.primary.img.url, [['ar_16:9', 'c_fill', 'g_auto'], 'w_375', 'dpr_2']), " 750w, ").concat(formatPrismicImage(this.payload.primary.img.url, [['ar_16:9', 'c_fill', 'g_auto'], 'w_1440']), " 1440w, ").concat(formatPrismicImage(this.payload.primary.img.url, [['ar_16:9', 'c_fill', 'g_auto'], 'w_1440', 'dpr_2']), " 2880w")
      };
    }
  }
};